import addError from '../../../utils/error.jsx';
import { request as getCountries } from '../actions/get';

export function request(data) {
    return {
        type: 'COUNTRY_UPDATE_REQUEST',
        data
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'COUNTRY_UPDATE_ERROR',
        errors
    };
}

export function finish(data) {
    return (dispatch) => {
        dispatch(getCountries());
        dispatch({
            type: 'COUNTRY_UPDATE_FINISH',
            data
        });
    };
}
